export class AskingMemory {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
}
